module.exports = __webpack_public_path__ + "static/media/VERISIGN.7143b52b.png";